import React from 'react';
import'./Pay.css';

const Pay = () => {
    return (
        <div className="pay-page my-4 p-4 w-75 rounded mx-auto justify-content-center align-items-center">
            <h1>Payment system is coming soon...</h1>
        </div>
    );
};

export default Pay;